import _ from 'lodash';
import qs from 'qs';
import Promise from 'bluebird';

import $ from '~/qwery';
import bean from '~/bean';
import axios from '~/axios';

export function waitForImages(el) {
    const images = document.querySelectorAll('img');
    return Promise.all(_.compact(_.map(images, img => {
        if (img.complete) {
            return;
        } else
            return new Promise((resolve, reject) => {
                img.addEventListener('load', () => {
                    resolve();
                });
            });
    })));
}

export function addToBasket(product_id, size_id) {
    return product_id
        ? axios.post('/basket', qs.stringify({
            product_id: product_id,
            size_id: size_id,
            amount: 1,
        }))
        : axios.get('/basket');
}


let callbacks = []
let textarea;

function mousedownEventHandler(e) {
    if (e.target.tagName == 'TEXTAREA')
        textarea = e.target;
}

function mouseupEventHandler(e) {
    if (textarea) {
        callbacks.forEach(callback => {
            callback(textarea)
        });
    }
    textarea = null;
}

export function onTextareaResize(callback) {
    if ( ! callbacks.length) {
        bean.on(window, 'mousedown', mousedownEventHandler);
        bean.on(window, 'mouseup', mouseupEventHandler);
    }
    callbacks.push(callback);
}

export function offTextareaResize(callback) {
    callbacks = callbacks.filter(c => c != callback);
    if ( ! callbacks.length) {
        bean.off(window, 'mousedown', mousedownEventHandler);
        bean.off(window, 'mouseup', mouseupEventHandler);
    }
}


export function addAfterPasteEvent(el) {
    const $el = $(el);
    bean.on($el[0], 'paste', e => {
        setTimeout(() => {
            bean.fire(e.target, 'afterpaste');
        });
    });
}



// WEBPACK FOOTER //
// ./makosh/assets/common.js